import { provideHttpClient, withFetch } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { CrgIconLibraryModule } from '@crg-library/crg-icon-library';
import { KomodoCoreWrappersModule } from '@komodo-design-system/komodo-core-angular-twelve-wrappers/dist/komodo-core-wrappers';
import { KwaAngular18Module } from '@komodo-design-system/komodo-kwa-angular-18';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { WINDOW } from '../core/window.token';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AppHeaderModule } from './components/app-header/app-header.module';
import { HomeModule } from './pages/home/home.module';
import { StudyDetailsModule } from './pages/study-details/study-details.module';
import { StudyPortfolioModule } from './pages/study-portfolio/study-portfolio.module';
import { SharedModule } from './shared.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    KwaAngular18Module,
    KomodoCoreWrappersModule,
    NgxSkeletonLoaderModule,
    StudyDetailsModule,
    StudyPortfolioModule,
    HomeModule,
    SharedModule,
    MatIconModule,
    MatDialogModule,
    CrgIconLibraryModule,
    AppHeaderModule
  ],
  providers: [
    provideHttpClient(withFetch()),
    { provide: 'Window', useValue: window },
    provideAnimationsAsync(),
    { provide: WINDOW, useValue: window }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule {}
